module.exports = __webpack_public_path__ + "img/ICON_MoneyHand_Colors.556968c4.svg";